<!-- 库房报溢数据操作 -->
<template>
   <div>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'"
                  :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                  @tabHeight="(val) => { mxHeight = val }">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <el-form class="baseForm" id="mainInfo" label-width="100px" :model="sendDataInfo"
                              ref="sendDataInfo" size="mini" :show-message="false">
                              <el-row v-if="dataActionBox.actionType != 2" ref="baseForm">
                                 <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1"
                                    v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                    :prop="formOneValue.entityField"
                                    :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                    <!-- 系统字段 -->
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                       v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                    <div v-if="formOneValue.isReserved == 0">
                                       <df-date class="form_codition" :isShowLong="false"
                                          :isdisabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"
                                          v-if="formOneValue.fieldType == 'date'"
                                          v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                       <!-- 发起类型 -->
                                       <el-select class="form_codition"
                                          v-else-if="formOneValue.entityField == 'ovmApptype'"
                                          v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择"
                                          :disabled="formOneValue.isChange == 0">
                                          <el-option v-for="item in JSON.parse(formOneValue.formatterContent)"
                                             :key="item.key" :label="item.value" :value="item.key">
                                          </el-option>
                                       </el-select>
                                       <el-input class="form_codition"
                                          v-else-if="formOneValue.entityField == 'ovmAppreason'" type="textarea"
                                          v-model.trim="sendDataInfo[formOneValue.entityField]"
                                          :maxlength="$store.state.inputLength"
                                          :disabled="formOneValue.isChange == 0"></el-input>
                                       <el-input class="form_codition" v-else
                                          v-model.trim="sendDataInfo[formOneValue.entityField]"
                                          :maxlength="$store.state.inputLength"
                                          :disabled="formOneValue.isChange == 0"></el-input>
                                    </div>
                                    <!-- 扩展字段 -->
                                    <div v-if="formOneValue.isReserved == 1">
                                       <!-- 自填 -->
                                       <el-input v-if="formOneValue.operatType == 0"
                                          v-model.trim="sendDataInfo[formOneValue.entityField]"
                                          :disabled="formOneValue.isChange == 0" :maxlength="$store.state.inputLength">
                                       </el-input>
                                       <!-- 选择数据来源 -->
                                       <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]"
                                          :disabled="formOneValue.isChange == 0" :maxlength="$store.state.inputLength"
                                          @focus="openSearch(formOneValue.searchId)">
                                       </el-input>
                                    </div>
                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 2">
                                 <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1"
                                    v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                       v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                    <span v-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                          sendDataInfo[formOneValue.entityField] }}</a>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                       <span v-if="sendDataInfo[formOneValue.entityField]">
                                          {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                       </span>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'formatter'">
                                       {{ $common.getIsGsp(formOneValue.formatterContent,
                                          sendDataInfo[formOneValue.entityField]) }}
                                    </span>
                                    <span
                                       v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay'">{{
                                          sendDataInfo[formOneValue.entityField]
                                             == 1 ? "是" : "否" }}</span>
                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                           <!-- 明细 -->
                           <el-form :inline="true" size="mini">
                              <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                 <el-button type="primary" size="mini" @click="addDetails()">新增</el-button>
                                 <!-- @focus="openExComponents(formOneValue.extractId)" -->
                                 <el-button type="primary" size="mini" @click="deleteDetails()">删除
                                 </el-button>
                                 <el-button type="primary" size="mini"
                                    @click="openExtSearch('15997092986521')">提取</el-button>
                              </div>
                              <el-table size="mini" ref="mxTableRef" :height="mxHeight" id="mxTable"
                                 :data="sendDataInfo.overflowDetails" border style="width: 100%">
                                 <el-table-column label="选择操作" width="80">
                                    <template slot-scope="scope">
                                       <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border
                                          size="mini">
                                          <i class="el-icon-thumb"></i>
                                       </el-radio>
                                    </template>
                                 </el-table-column>
                                 <el-table-column align="center" width="180" :prop="formOneValue.entityField"
                                    :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in mxForm"
                                    :key="formOneKey" v-if="formOneValue.isShow == 1">
                                    <template slot-scope="scope">
                                       <!-- 系统字段 -->

                                       <!-- 商品 -->
                                       <el-input :ref="formOneValue.entityField"
                                          v-if="formOneValue.entityField == 'bgmName' && dataActionBox.actionType != 2"
                                          v-model.number="sendDataInfo.overflowDetails[scope.$index].bgmName"
                                          @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)"
                                          clearable>
                                          <el-button
                                             @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)"
                                             slot="append" icon="el-icon-search"></el-button>
                                       </el-input>
                                       <el-input :ref="formOneValue.entityField"
                                          v-else-if="formOneValue.fieldType == 'search' && dataActionBox.actionType != 2"
                                          v-model.number="sendDataInfo.overflowDetails[scope.$index][formOneValue.entityField]"
                                          @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)"
                                          clearable>
                                          <el-button
                                             @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)"
                                             slot="append" icon="el-icon-search"></el-button>
                                       </el-input>
                                       <!-- 报溢数量 -->
                                       <el-input :ref="formOneValue.entityField"
                                          v-else-if="formOneValue.entityField == 'ovdNumber' && dataActionBox.actionType != 2"
                                          v-model.number="sendDataInfo.overflowDetails[scope.$index][formOneValue.entityField]"
                                          @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)"
                                          type="number" min="0"></el-input>
                                       <!-- 有效期 -->
                                       <span v-else-if="formOneValue.entityField == 'expidate'">
                                          <div v-if="scope.row[formOneValue.entityField]">
                                             {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                          </div>
                                       </span>
                                       <!-- 生产日期 -->
                                       <span v-else-if="formOneValue.entityField == 'prodate'">
                                          <span v-if="scope.row[formOneValue.entityField]">
                                             {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                          </span>
                                       </span>
                                       <span v-else>
                                          {{ sendDataInfo.overflowDetails[scope.$index][formOneValue.entityField] }}
                                       </span>
                                    </template>
                                 </el-table-column>

                              </el-table>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>

            <!-- 页脚 -->
            <div class="foot">
               <div>
                  <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary"
                     @click="showPrintPlan">打印
                  </el-button>
                  <el-button type="primary" @click="initActionBox('sendDataInfo')"
                     v-if="dataActionBox.actionType != 2">取消</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                     v-if="dataActionBox.actionType == 0">保存</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                     v-if="dataActionBox.actionType == 1">保存</el-button>
               </div>
               <div v-if="footForm">
                  <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline">
                     <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                        <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                     </el-form-item>
                  </el-form>
               </div>
            </div>
         </div>
      </div>
      <!-- 检索方案弹窗 -->
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
         :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
            @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
      <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth"
         :modal-append-to-body='true' :append-to-body="true">
         <ExtractionScheme ref="extractionScheme" :id="exId" :ppId="ppId" @TranData="getDataByChen" @getWidth="getWidth"
            @sendTitle="getExtractName" />
      </el-dialog>
   </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
export default {
   name: "stockOverflowAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      ExtractionScheme,
   },
   data() {
      //这里存放数据
      return {
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {
            ovmAppdate: "",
            ovmAppreason: "",
            ovmApptype: 0,
            ovmReserves1: "",
            ovmReserves2: "",
            ovmReserves3: "",
            ovmReserves4: "",
            ovmReserves5: "",
            ovmReserves6: "",
            ovmId: "",
            overflowDetails: [],
            totalMoney: 0,
            totalNumber: 0,
            totalCount: 0,
         },
         detaislDataInfo: {},
         showTabs: "",
         formDataList: [],
         seTitle: "", //检索
         DialogVisible: false,
         seWidth: "0",
         seId: 0,
         parentSearchData: {},
         selectedDetailsIndex: 0, //选择索引
         seIndex: 0, //检索焦点索引
         mxHeight: 0,
         tabForm: [],
         mxForm: [],
         footForm: [],
         sField: "",
         exId: "",
         ppId: "iecode",
         DialogExtract: false,
         exWidth: "",
         exTitle: "",
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.overflowDetails": {
         handler: function (newValue, oldValue) {
            this.sendDataInfo.totalCount = 0; //总条目数
            this.sendDataInfo.totalMoney = 0; // 总金额
            this.sendDataInfo.totalNumber = 0; // 总数量
            newValue.forEach((item, keys) => {
               if (item.ovdNumber <= 0) {
                  //报溢数量
                  this.sendDataInfo.overflowDetails[keys].money = 0;
                  this.sendDataInfo.overflowDetails[keys].psmoney = 0;
                  return false;
               }

               // 计算金额 单价*数量
               this.sendDataInfo.overflowDetails[keys].money =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(item.price, item.ovdNumber)
                  );

               // 计算含税金额 含税价格*数量
               this.sendDataInfo.overflowDetails[keys].psmoney =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(item.psprice, item.ovdNumber)
                  );

               this.sendDataInfo.totalMoney = NP.plus(
                  this.sendDataInfo.totalMoney,
                  this.sendDataInfo.overflowDetails[keys].psmoney
               );

               this.sendDataInfo.totalNumber = NP.plus(
                  this.sendDataInfo.totalNumber,
                  item.ovdNumber
               );
            });
            this.sendDataInfo.totalCount = newValue.length;
         },

         deep: true,
      },
   },
   //方法集合
   methods: {
      //触发提取
      openExtSearch(id) {
         this.exId = id;
         this.exId = id;
         this.DialogExtract = true;
      },
      //提取返回
      async getDataByChen(val) {
         console.log(val,'val444')
         if (val != "" || val != undefined) {
            for (let key in val) {
               if (key == "arrlistbychen") {
                  this.sendDataInfo.overflowDetails = val.arrlistbychen;
               } else {
                  this.sendDataInfo[key] = val[key];
                  this.sendDataInfo.totalMoney = 0
                  this.sendDataInfo.totalNumber = 0
                  this.sendDataInfo.totalCount = 0
               }
            }
            this.sendDataInfo.overflowDetails.forEach(item => {
               this.sendDataInfo.totalMoney += item.rrdPsmoney
               this.sendDataInfo.totalNumber += item.oldNum
            })
            this.sendDataInfo.totalCount = this.sendDataInfo.overflowDetails.length
            // let responseData = await this.$http.getOrderId({ ids: [val.psaiId] });
            // this.sendDataInfo.pisOrderauxinfVo = responseData.result;
            this.DialogExtract = false;
            this.$nextTick(() => {
               this.selectedDetailsIndex = 0
               let refsElTable = this.$refs.mxTableRef[0]
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(this.sendDataInfo.overflowDetails[this
                  .selectedDetailsIndex]);
               this.nextFocus(0)
            })
         }
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getExtractName(e) {
         this.exTitle = e;
      },
      extract(sId) {
         this.DialogVisible = true;
         this.seId = sId;
         this.seType = "extract";
         this.parentSearchData.foType = 1
         console.log(this.sendDataInfo);
         // this.seIndex
      },
      showPrintPlan() {
         // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(
               this.actionData.orderId,
               this.actionData.printSouce,
               this.actionData.printJurId
            );
         } else {
            return;
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.sendDataInfo[item] = val[item];
         });
      },
      // 表格赋值字段
      mxParamValue(val) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.sendDataInfo.overflowDetails[this.seIndex][item] = val[item];
         });
         this.sendDataInfo.overflowDetails.splice(1, 0);
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.sField = sField;
         this.seIndex = index;
         this.DialogVisible = true;
         this.seId = sId;
         this.parentSearchData[type] =
            this.sendDataInfo.overflowDetails[index][type];
         if (type == "lotno") {
            for (const key in this.sendDataInfo.overflowDetails[index]) {
               this.parentSearchData[key] =
                  this.sendDataInfo.overflowDetails[index][key];
            }
         }
      },
      //检索带回数据
      changeInputModel(val) {
         console.log("返hui", val);
         if (val != "" || val != undefined) {
            this.DialogVisible = false; //关闭商品检索窗口
            //赋值给当前行
            if (val.bgmId) {
               if (this.sendDataInfo.overflowDetails.length == 0) {
                  this.sendDataInfo.overflowDetails.push({})
               }
               for (const key in val) {
                  if (Object.hasOwnProperty.call(val, key)) {
                     this.$set(
                        this.sendDataInfo.overflowDetails[this.seIndex],
                        key,
                        val[key]
                     );
                  }
               }
               this.tableNextFocus("ovdNumber", this.seIndex);
            }
            this.mxParamValue(val);
         } else {
            this.DialogVisible = false;
            this.$message({
               message: "检索失败",
               type: "error",
            });
         }
         console.log("检索返后", this.sendDataInfo);
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },

      //确认新增
      async sendDataAction(formName) {
         let flag = false;
         this.$refs[formName].validate((valid) => {
            if (valid) {
            } else {
               this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });
               flag = true;
               return false;
            }
         });
         if (flag) return false;
         //检查每个明细的报溢数量
         let numFlag = this.sendDataInfo.overflowDetails.every(
            (v) => v.ovdNumber > 0
         );
         if (!numFlag) {
            this.$message({
               message: "报溢数量必须大于0",
               type: "error",
            });
            return false;
         }
         let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
         if (this.dataActionBox.actionType == 0) {
            var responseData = await this.$http.addStockOverflow(sendData);
         } else {
            var responseData = await this.$http.setStockOverflow(sendData);
         }
         if (responseData.status == 200) {
            this.$emit("drawerCancel", 1);
            this.init();
            this.$message({
               message: "操作成功",
               type: "success",
            });
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //新增明细
      addDetails() {
         var flag = false;
         if (this.sendDataInfo.overflowDetails.length > 0) {
            this.sendDataInfo.overflowDetails.forEach((item) => {
               if (item.bgmId == "") {
                  flag = true;
                  this.$nextTick(() => {
                     this.selectedDetailsIndex = Number(
                        this.sendDataInfo.overflowDetails.length - 1
                     );
                     this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                     let refsElTable = this.$refs.mxTableRef;
                     refsElTable.clearSelection();
                     refsElTable.toggleRowSelection(
                        this.sendDataInfo.overflowDetails[
                        this.selectedDetailsIndex
                        ]
                     );
                  });
               }
            });
         }
         if (flag) {
            return;
         }
         this.sendDataInfo.overflowDetails.push({});
         var index = this.sendDataInfo.overflowDetails.length - 1;
         for (const key in this.detaislDataInfo) {
            this.$set(
               this.sendDataInfo.overflowDetails[index],
               key,
               this.detaislDataInfo[key]
            );
         }
         this.$nextTick(() => {
            this.selectedDetailsIndex = Number(
               this.sendDataInfo.overflowDetails.length - 1
            );
            this.tableNextFocus("bgmName", this.selectedDetailsIndex);
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
               this.sendDataInfo.overflowDetails[this.selectedDetailsIndex]
            );
         });
      },
      // 表格切换焦点方法
      tableNextFocus(field, index) {
         this.seIndex = index;
         if (field == "keydown") {
            if (this.sendDataInfo.overflowDetails[index + 1] != undefined) {
               this.$refs["bgmName"][index + 1].focus();
               this.selectedDetailsIndex = index + 1;
               this.$nextTick(() => {
                  let refsElTable = this.$refs.mxTableRef;
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(
                     this.sendDataInfo.overflowDetails[this.selectedDetailsIndex]
                  );
               });
               return;
            }
            this.addDetails("sendDataInfo");
            return;
         }
         this.$refs[field][index].focus();
      },
      //删除明细
      deleteDetails() {
         if (this.sendDataInfo.overflowDetails.length < 1) {
            this.$message({
               message: "请先添加明细",
               type: "error",
            });
            return false;
         }
         this.sendDataInfo.overflowDetails.splice(this.selectedDetailsIndex, 1);
         this.selectedDetailsIndex = 0;
      },
      //初始化
      init() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = "";
         }
         this.sendDataInfo.totalCount = 0; //总条目数
         this.sendDataInfo.totalMoney = 0; // 总金额
         this.sendDataInfo.totalNumber = 0; // 总数量

         this.sendDataInfo.ovmAppdate = this.$moment().valueOf();

         this.sendDataInfo.ovmApptype = 0;
         this.sendDataInfo.overflowDetails = [];
      },
      //取消
      initActionBox(formName) {
         this.$confirm(
            "确定取消" + this.dataActionBox.boxTitle + "吗?",
            "提示",
            {
               confirmButtonText: "确定",
               cancelButtonText: "取消",
               type: "warning",
            }
         )
            .then(() => {
               this.$emit("drawerCancel", 0);
               this.init();
               this.$refs[formName].resetFields();
            })
            .catch(() => { });
      },
      async isShowData(name, value) {
         this.sendDataInfo[name] = value;
      },

      //父级传入
      openBox() {
         this.dataActionBox.actionType = this.actionData.cate;
         this.formDataList = this.actionData.formData;
         var oldData = this.actionData.oldData;
         this.showTabs = this.actionData.formData[0].jciName;
         this.filterMainField();
         this.init();
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            this.sendDataInfo.overflowDetails = [];
            for (let key in this.sendDataInfo) {
               this.sendDataInfo[key] = oldData[key];
               if (key == "overflowDetails") {
                  this.sendDataInfo.overflowDetails = [];
                  oldData.overflowDetails.forEach((item, keys) => {
                     this.sendDataInfo.overflowDetails.push(item);
                  });
               }
            }
            console.log(this.sendDataInfo);
         } else {
            this.dataActionBox.boxTitle = "查看信息";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.sendDataInfo[key] = dataInfo[key];
            }
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight();
               } else {
                  this.mxHeight = this.$common.getHeight();
               }
            }, 16.7);
         });
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = [];
         this.formDataList.forEach((item) => {
            if (item.jciType == 1) {
               mainFormList.push(item);
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
               this.mxForm.forEach((item1) => {
                  if (item1.fieldType == "number") {
                     this.$set(this.detaislDataInfo, item1.entityField, 0);
                  } else if (item1.fieldType == "search" && item1.setField) {
                     var arr = item1.setField.split(",");
                     arr.forEach((item2) => {
                        this.$set(this.detaislDataInfo, item2, "");
                     });
                  } else {
                     this.$set(this.detaislDataInfo, item1.entityField, "");
                  }
               });
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
            }
         });
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key));
            this.tabForm[i].jurconfigform = [];
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1)
                  this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
            }
         });
         var arr = [{ entityField: "overflowDetails" }];
         var obj = this.$common.filterMainFields(
            this.formDataList,
            arr,
            mainFormList[0]
         );
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key]);
         }
         this.$set(this.sendDataInfo, "ovmApptype", 0);
         this.$set(this.sendDataInfo, "ovmAppdate", this.$moment().valueOf());
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         this.openBox();
      });
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
   width: 100%;
}

.el-drawer {
   outline: none;
}

/* 表格样式更改*/
#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
   margin-bottom: 0;
}
</style>